import { nsT, useT } from '../../index';
import type zh from './zh-CN';

export type HomeMessages = typeof zh;
export const useHomeT = () => useT<HomeMessages>('home');
export const homeT = nsT<HomeMessages>('home');
